import { render, staticRenderFns } from "./CommodityDialog.vue?vue&type=template&id=5c1cbf7c&scoped=true&"
import script from "./CommodityDialog.vue?vue&type=script&lang=js&"
export * from "./CommodityDialog.vue?vue&type=script&lang=js&"
import style0 from "./CommodityDialog.vue?vue&type=style&index=0&id=5c1cbf7c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c1cbf7c",
  null
  
)

export default component.exports